import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-back",
  "use": "icon-icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-back\"><path class=\"cls-1\" d=\"M133.2,705.4c-38.7,0-70-31.3-70-70s31.3-70,70-70h588.7s-127.4-127.4-127.4-127.4c-27.3-27.3-27.3-71.7,0-99,27.3-27.3,71.7-27.3,99,0l246.9,246.9c20,20,26,50.1,15.2,76.3-10.8,26.2-36.4,43.2-64.7,43.2H133.2s0,0,0,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol